import React, { useContext, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderInner from "../../Components/HeaderInner";
import { Zoom } from "react-reveal";
import { GetActivitiesCategories } from "../../API/activities";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import { ThemeContext } from "../../context/ThemeContext";
import { useBusinessNameContext } from "../../context/BusinessName";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import { trackCategoryViewed } from "../../utils/mixpanel";

function ActivitiesCategories() {
  const { businessName } = useBusinessNameContext();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  const { theme } = useContext(ThemeContext);
  const lang = localStorage.getItem("lang");

  let categoriesData;
  let bgColor;
  let color;
  let text;
  let activitiesCategories;

  const { data, isLoading, error } = GetActivitiesCategories(
    params.room_uuid,
    params.company_uuid,
    lang
  );

  if (!isLoading) {
    if (error) {
      if (error?.response?.status === 404) {
        navigate(`/not-found`);
      }
    } else {
      if (data?.data?.status === false) {
        navigate(`/${params.room_uuid}/qr-scan`);
      } else {
        categoriesData = data?.data;
        activitiesCategories = categoriesData?.activities_categories;
        color = categoriesData?.color;
        bgColor = categoriesData?.header_color;
        text = categoriesData?.header_title;

        console.log("ShowActivitiesCategories", categoriesData);
      }
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  useEffect(() => {
    if (!isLoading && !error && activitiesCategories?.length > 0) {
      trackCategoryViewed({
        category_id: 31,
        category_name: text || "",
        category_type: "activities",
      });
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading && !error && data?.data.activities_categories.length === 1) {
      navigate(
        `/${params.room_uuid}/activities/category-activities/${
          params.company_uuid
        }/${activitiesCategories[0].id.toString()}`,
        { replace: true }
      );
    }
  }, [isLoading, error, data, navigate, params.room_uuid]);

  return (
    <div
      className={`
  ${
    theme && businessName === "Beno Jumeirah Sport Activity"
      ? "food pb-1 activities-custom-styles"
      : ""
  }
  ${theme ? "food pb-1" : ""}
`}
    >
      {theme ? <Title title={text} /> : <HeaderInner headerName={text} />}
      <main className="home-main bg-white pt-3">
        <div className={theme ? "box_food" : ""}>
          {isLoading ? (
            <CustomBusinessServiceLoader
              businessName={businessName}
              loader={"spa"}
            />
          ) : activitiesCategories ? (
            activitiesCategories.map((category, idx) => {
              return theme ? (
                <div key={idx}>
                  <Link
                    to={`/${params.room_uuid}/activities/category-activities/${
                      params.company_uuid
                    }/${category.id.toString()}`}
                  >
                    <img src={category?.image} alt="" className="booking_img" />
                    <img src={Overllay} alt="" className="overlay" />
                    <div className="text_food">
                      <h5 className="">{category.name}</h5>
                    </div>
                  </Link>
                </div>
              ) : (
                <div id={category.name} key={idx}>
                  <Zoom>
                    <div
                      className="con-img-container v3"
                      onClick={() =>
                        navigate(
                          `/${
                            params.room_uuid
                          }/activities/category-activities/${
                            params.company_uuid
                          }/${category.id.toString()}`
                        )
                      }
                    >
                      <div className="con-img">
                        <img src={category.image} alt="" />
                        <p></p>
                      </div>
                    </div>
                    <div className="con-text-container">
                      <p>{category.name}</p>
                      <hr className="mb-0 dark" />
                    </div>
                  </Zoom>
                </div>
              );
            })
          ) : null}
        </div>
      </main>
      {theme && businessName !== "Beno Jumeirah Sport Activity" && (
        <NewFooter />
      )}
    </div>
  );
}

export default ActivitiesCategories;
